// Idle channels (#596): with "Group idle channels" on, a channel whose newest message is 24 hours old or more, or that has
// no message at all, leaves its category for one "Idle" group at the bottom of the channel list. The group is worked out
// on the client from the Chats rows' `lastTs` and is never stored. One rule for every client; the cases are
// shared/cases/idle-channels.json, which the Swift and Kotlin ports run too; the web imports this file.

/** A channel is idle when its newest message is this old or older: 24 hours. */
export const IDLE_MS = 24 * 60 * 60 * 1000;

/** What the rule reads. Times are ms since 1970. */
export interface IdleInput {
  /** The newest message's time; null when the channel has no message. */
  newestAt: number | null;
  /** The time to judge at. */
  now: number;
  /** The channel is the one open now: it stays where it is. */
  open: boolean;
  /** The channel has an unread @mention: it stays where it is. */
  mention: boolean;
}

/**
 * Whether the channel goes into the Idle group. The open channel and a channel with an unread mention never do. A channel
 * with no message is idle. Otherwise it is idle when its newest message is `IDLE_MS` old or more, so 23 h 59 m is not and
 * 24 h 0 m is. A message from the future (a clock that runs ahead) is not old, so not idle.
 */
export function isIdleChannel({ newestAt, now, open, mention }: IdleInput): boolean {
  if (open || mention) return false;
  if (newestAt === null) return true;
  return now - newestAt >= IDLE_MS;
}
